export class Semaphore {
    #queue = [];
    #available;
    constructor(max) {
        this.#available = max;
    }
    execute(func) {
        return new Promise((resolve, reject) => {
            const wrapped = () => func().then(resolve).catch(reject);
            if (this.#available > 0) {
                this.#available--;
                wrapped().finally(() => this.onComplete());
            }
            else {
                this.#queue.push(wrapped);
            }
        });
    }
    onComplete() {
        const next = this.#queue.shift();
        if (next) {
            next().finally(() => this.onComplete());
        }
        else {
            this.#available++;
        }
    }
}
